import { getRemoteConfig } from 'firebase/remote-config';
import { initializeApp } from 'firebase/app';
import firebaseConfig from './remote-config.json';
import { isTruthy } from './utils';

let remoteConfig: any = {
  settings: {},
};

const env = import.meta.env ?? process.env;
if (!isTruthy(env.VITE_IS_PLAYWRIGHT) || !isTruthy(env.VITE_IS_LOCAL)) {
  const app = initializeApp(firebaseConfig);
  remoteConfig = getRemoteConfig(app);
}

/*
 For development only update this to faster intervals
 12 Hours on production recommended by Firebase
*/
remoteConfig.settings.minimumFetchIntervalMillis = parseInt(
  env.VITE_REMOTE_CONFIG_FETCH_INTERNVAL || '43200000',
);

export default remoteConfig;
